'use strict';
import React from 'react';
import { Navigation } from 'react-router';

import t from 'tcomb-form';
import flux from 'utils/flux';
import email from 'email-validation';

var Form = t.form.Form;

var PasswordForgotten = t.struct({
    email: t.subtype(t.Str, (s) => email.valid(s))
});

var PasswordForgottenModal = React.createClass({
    displayName: 'PasswordForgottenModal',
    mixins: [ Navigation ],
    propTypes: {
        hasError: React.PropTypes.oneOfType([
            React.PropTypes.string,
            React.PropTypes.bool
        ])
    },
    getInitialState() {
        return {
            email: '',
            resetSuccess: false
        };
    },
    onChange(value) {
        this.setState({value});
    },
    showLogin(e) {
        e.preventDefault();
        flux.getActions('modals').openModal('Login');
    },
    onSubmit(evt) {
        evt.preventDefault();
        var data = this.refs.form.getValue();
        if (data) {
            flux.getStore('app').resetPassword(data).then(() => {
                this.setState({resetSuccess: true});
            });
        }
    },
    renderError() {
        if (this.props.hasError) {
            return (
                <div className="content__error">
                    {this.props.hasError}
                </div>
            );
        }
    },
    render() {
        if (this.state.resetSuccess) {
            return (<h4 className="register__success">{flux.t('reset_password_requested')}</h4>);
        }

        var options = {
            auto: 'placeholders',
            fields: {
                email: {
                    error: flux.t('validation_email'),
                    label: flux.t('account_username'),
                    attrs: {
                        autoFocus: true
                    }
                }
            }
        };

        return (
            <div>
                <h4>{flux.t('account_forgot_password_title')}</h4>
                <form onSubmit={this.onSubmit}>
                    <Form
                      ref="form"
                      type={PasswordForgotten}
                      options={options}
                      value={this.state.value}
                      onChange={this.onChange}
                    />
                    {this.renderError()}
                    <button type="submit" className="btn btn-primary btn-arrow">
                        {flux.t('reset_password')}
                        <i className="gopro-chevron-right" />
                    </button>
                </form>
                <hr className="white" />
                <button onClick={this.showLogin} type="button" className="btn btn-white btn-arrow-left">
                    <i className="gopro-chevron-left" />
                    {flux.t('back_to_login')}
                </button>
            </div>
        );
    }
});

module.exports = PasswordForgottenModal;



// WEBPACK FOOTER //
// ./app/components/modals/passwordForgottenModal.jsx